import {
  DataSourceSetupComposite,
  enumATSModes
} from "@/appComponents/Blocks/Modals/SettingsModal/ChartSettings/DataSourceConfiguration/DataSources/DataSourceSetupComposite";
import { CopyDisplayText } from "@/appComponents/Blocks/Composites/CopyDisplayText/CopyDisplayText";
import { Alert, Divider, isNullish } from "@theorgchartdev/storybook";
import { Fragment, useState } from "react";
import { useTopic } from "@/hooks/useTopic";
import cx from "classnames";
import { kPaycomHeaders } from "@coreapp/constants";
import { appcstrp } from "@coreapp/utils/appcstrp";

export const PaycomSetupComposite = ({ config, onChange, index, importType, chartConfig }) => {
  const isAdditionalSource = importType !== "import";
  const atsType = isAdditionalSource ? enumATSModes.notATS : undefined;

  const [ipAddress, setIPAddress] = useState(null);

  const handleAuthValidation = data => {
    setIPAddress(data?.whitelistip);
  };

  useTopic("AuthValidation", handleAuthValidation);

  const paycomAdditionalFields = kPaycomHeaders.map(paycomHeader => {
    return {
      value: { headerName: paycomHeader.alias, headerLabel: paycomHeader.name },
      label: paycomHeader.name
    };
  });

  const customFields = config["CustomADPFields"] ?? [];
  const customAdditionalFields = customFields.map(customField => {
    return {
      value: { headerName: customField.name, headerId: customField.id },
      label: customField.name
    };
  });

  const additionalFieldOptions = paycomAdditionalFields.concat(customAdditionalFields);

  const selectedAdditionalFields = config.customheaders ?? [];

  const onAdditionalFieldToggle = e => {
    let option = e.value;
    let newHeader = option?.value;
    if (!newHeader) return;
    let customHeaders = config.customheaders ?? [];
    var currentIndex = customHeaders.findIndex(
      sourceItem => JSON.stringify(sourceItem) === JSON.stringify(newHeader)
    );
    if (currentIndex > -1) customHeaders.splice(currentIndex, 1);
    else customHeaders.push(newHeader);
    onChange({ ...config, customheaders: customHeaders });
  };

  return (
    <DataSourceSetupComposite
      config={config}
      onChange={onChange}
      index={index}
      chartConfig={chartConfig}
      showInputControls
      showConfiguration={isAdditionalSource}
      showLoadHeaders={isAdditionalSource}
      additionalFieldOptions={additionalFieldOptions}
      selectedAdditionalFields={selectedAdditionalFields}
      onAdditionalFieldChange={onAdditionalFieldToggle}
      showAdditionalFields
      importType={importType}
      ATSType={atsType}
    >
      {!isNullish(ipAddress) && (
        <Fragment>
          <Divider vertical={false} />
          <Alert
            className={cx("oc-padding-small", "oc-text-small", "oc-data-source-details")}
            severity={"warning"}
          >
            {appcstrp("PaycomIP", ":")}
            <CopyDisplayText value={ipAddress} />
          </Alert>
        </Fragment>
      )}
    </DataSourceSetupComposite>
  );
};
